var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_1391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_1391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 1.17996L44 12.729V17.092L39.824 19.522L44 21.54V26.074L39.824 28.521L44 30.865V35.517L24 47.375L4 35.517V30.865L8.176 28.521L4 26.074V21.54L8.176 19.521L4 17.091V12.73L24 1.17996Z",
    fill: "url(#paint0_linear_1_1391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 12.729L24 1.17896L4 12.73M24 23.97L44 12.73V17.093L39.824 19.523M24 47.374L44 35.516V30.864M24 47.374L4 35.517V30.865M24 47.374V42.808M4 30.865L24 42.808M4 30.865L8.176 28.521M24 42.808L44 30.865L39.824 28.521M8.176 19.522L4 17.092V12.728L24 23.968V28.725L8.176 19.522ZM8.176 19.522L4 21.54M24 28.726L39.824 19.521L44 21.54M24 33.431L44 21.54M24 33.431L4 21.54M24 33.431V38.103M44 21.54V26.074L39.824 28.521M4 21.54V26.074L8.176 28.521M24 38.103L8.176 28.521M24 38.103L39.824 28.521",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1391",
    x1: 24,
    y1: 1.17996,
    x2: 24,
    y2: 47.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.300049)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.300049)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.300049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimple);
export default __webpack_public_path__ + "static/media/simple.a1acd6832b2adb8ae397f6c373cc86b0.svg";
export { ForwardRef as ReactComponent };